import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Trophy } from 'lucide-react';

export const PreviewSection = ({
  menuColor,
  badgePreview,
  teamName,
  setBadgePreview
}) => {
  return (
    <Card data-testid="preview-card">
      <CardHeader>
        <CardTitle className="text-xl font-semibold font-title">Preview</CardTitle>
      </CardHeader>
      <CardContent>
        <div 
          className="flex items-center gap-4 p-4 rounded-xl transition-colors"
          style={{ backgroundColor: menuColor }}
        >
          {badgePreview ? (
            <img 
              src={badgePreview} 
              alt="Badge" 
              className="w-12 h-12 rounded-xl object-cover"
              onError={() => setBadgePreview('')}
            />
          ) : (
            <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center">
              <Trophy className="w-6 h-6 text-white/70" strokeWidth={1.5} />
            </div>
          )}
          <div>
            <h3 className="text-lg font-bold text-white font-title">
              {teamName || 'My Team'}
            </h3>
            <p className="text-xs text-white/70">Team Manager</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PreviewSection;
